module.exports = __webpack_public_path__ + "img/flex-align-right.921f0f60.svg";